import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../../lib/axios';

export const useCommsTemplates = (params?: { channel?: string; search?: string; page?: number }) =>
  useQuery({
    queryKey: ['comms', 'templates', params],
    queryFn: async () => {
      const r = await axiosInstance.get('/comms/templates', { params });
      return r.data;
    },
    staleTime: 30000,
    refetchOnWindowFocus: false,
  });

export const useCreateCommsTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { name: string; content: string; channel?: string; variables?: string[] }) =>
      axiosInstance.post('/comms/templates', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['comms', 'templates'] }),
  });
};

export const useUpdateCommsTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: number; name?: string; content?: string; channel?: string; variables?: string[] }) =>
      axiosInstance.put(`/comms/templates/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['comms', 'templates'] }),
  });
};

export const useDeleteCommsTemplate = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => axiosInstance.delete(`/comms/templates/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['comms', 'templates'] }),
  });
};

export const useBulkSendMessage = () =>
  useMutation({
    mutationFn: (data: { client_ids: number[]; message: string; channel: string; template_id?: number }) =>
      axiosInstance.post('/comms/bulk-send', data),
  });
